<script lang="ts">
	import { getDeviceSettings } from 'src/stores/device-runtime/status-selectors';
	import { devices_settings } from 'src/stores/device-runtime/status';
	//Services
	import { format } from '../../../../services/i18n';
	import { gen2Request } from '../../../../services/gen_2_http_reqs';
	//Constants
	import { DEVICE_MAX_POWER_DEFAULTS } from '../../../../constants';
	//Helpers
	import {
		get_gen_2_component_from_category,
		real_id,
		get_device_component_index,
	} from '../../../../helpers/interface_helpers';
	//Stores
	//Types
	import type { SettingRequest } from '../../../../types/requests/settings/setting';
	//Design system components
	import { Button, Text, Input, toast } from '@Shelly/shelly-design-system';
	import { makeNumbersPrimaryAndBold } from 'src/helpers/utilities';
	import { restrictDecimalNumberInput } from 'src/helpers/number_input_helpers';
	import { getContext, onDestroy } from 'svelte';
	import type { Writable } from 'svelte/store';
	import { showNewLayout } from 'src/stores/toDelete/new_layout';
	import type { SidepanelStickyBottomProps } from 'src/components/Sidepanel/sidepanel-types';

	$: settingsStore = getDeviceSettings(id);
	export let device;

	const id = real_id(device.id);
	const deviceType = get_gen_2_component_from_category(device);
	const index = get_device_component_index(device);
	const componentKey = `${deviceType}:${index}`;
	$: settings = $settingsStore || {};
	$: componentSettings = $settingsStore?.[componentKey];

	let unit = 'W';
	// const prop = $format('prop_power_meter', { default: 'the power' });

	// let enabled =
	// 	typeof $settingsStore[`${deviceType}:${device.channel}`]
	// 		.power_limit !== 'object';

	let value;
	$: if (value === undefined && componentSettings) {
		value = componentSettings.power_limit || 0;
	}

	// let cacheEnabled = enabled;
	// let cacheValue = value;

	let loading: boolean = false;
	$: error =
		+value < min || +value > max
			? $format('error_out_of_range', {
					default: `Value ${value}${unit} is out of range. Please provide a value within the limits. (${min}${unit} — ${max}${unit})`,
					values: { value, max, min, unit },
				})
			: '';

	// $: info = $format('info_value_range', {
	// 	default: `Configure Shelly device to turn off when ${prop} reaches ${value} ${unit}. Max: ${max} ${unit}.`,
	// 	values: { prop, value, max, unit }
	// });

	const min = 0;
	const max = DEVICE_MAX_POWER_DEFAULTS[device.type];

	// const onEnable = () => {
	// 	enabled = !enabled;
	// };

	const setPowerProtection = async () => {
		if (!componentSettings) return;

		if (value === '') {
			value = max;
		}
		// if (cacheValue !== value || cacheEnabled !== enabled) {
		if (+value < min || +value > max) {
			return toast.open({
				type: 'danger',
				title: $format('power_protection_limit_err_toast'),
			});
		}

		const params = {
			id: index,
			config: {
				power_limit: +value,
				voltage_limit: componentSettings.voltage_limit,
				current_limit: componentSettings.current_limit,
			},
		};
		loading = true;
		const res: SettingRequest = await gen2Request(device, `${deviceType}.setconfig`, params);

		if (res.isok) {
			settings[componentKey].power_limit = value;
			devices_settings.update_devices_settings(id, settings);

			toast.open({
				type: 'success',
				title: $format('power_protection_save_scc_toast', {
					values: { value: value },
				}),
			});
			// !enabled
			// 	? toast.open({
			// 			type: 'success',
			// 			title: $format('power_protection_disable_scc_toast')
			// 	  })
			// 	: toast.open({
			// 			type: 'success',
			// 			title: $format('power_protection_save_scc_toast', {
			// 				values: { value: value }
			// 			})
			// 	  });
			// cacheValue = value;
			// cacheEnabled = enabled;
		} else {
			// enabled = cacheEnabled;
			// value = cacheValue;

			toast.open({
				type: 'danger',
				title: $format('power_protection_save_err_toast'),
			});
			// !enabled
			// 	? toast.open({
			// 			type: 'danger',
			// 			title: $format('power_protection_disable_err_toast')
			// 	  })
			// 	: toast.open({
			// 			type: 'danger',
			// 			title: $format('power_protection_save_err_toast')
			// 	  });
		}
		loading = false;
		// }
	};

	const stickyBottomAction =
		getContext<Writable<SidepanelStickyBottomProps | null>>('stickyBottomAction');

	$: if (stickyBottomAction) {
		if ($showNewLayout) {
			stickyBottomAction.set({
				onClick: setPowerProtection,
				loading,
				disabled: loading || !componentSettings,
			});
		} else {
			stickyBottomAction.set(null);
		}
	}

	onDestroy(() => {
		stickyBottomAction?.set(null);
	});
</script>

<!-- <Checkbox size="m" class="mb-s" checked={enabled} on:click={onEnable}
	>{$format('label_enable')}</Checkbox
> -->

<Text styleType="controls-small" class="mb-s">
	{@html makeNumbersPrimaryAndBold(
		`${$format('max_power_prot_description', {
			values: { value },
			default: `Device will turn off when power reaches ${value} W.`,
		})}`,
	)}
</Text>

<Input
	on:input={(e) => restrictDecimalNumberInput(e, 2)}
	bind:value
	size="m"
	type={'number'}
	{min}
	{max}
	info={$format('range_min_max_watts_value', {
		default: 'Range: {min} W - {max} W.',
		values: { min, max },
	})}
	{error}
	step={1}
	on:enter={setPowerProtection}
	aria-label={$format('max_power_prot_description', {
		default: 'Max power protection',
	})}
	id="input-0t8w5ow"
/>
{#if !$showNewLayout}
	<Button
		class="mt-s"
		{loading}
		disabled={loading}
		size="m"
		width="full"
		on:click={setPowerProtection}
	>
		{$format('button_save')}
	</Button>
{/if}
